/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskWorkflowItemPicklistOption } from './TaskWorkflowItemPicklistOption';
import {
    TaskWorkflowItemPicklistOptionFromJSON,
    TaskWorkflowItemPicklistOptionFromJSONTyped,
    TaskWorkflowItemPicklistOptionToJSON,
    TaskWorkflowItemPicklistOptionToJSONTyped,
} from './TaskWorkflowItemPicklistOption';

/**
 * 
 * @export
 * @interface FindAllLeadTaskWorkflowItemPicklistOptions200Response
 */
export interface FindAllLeadTaskWorkflowItemPicklistOptions200Response {
    /**
     * 
     */
    data: Array<TaskWorkflowItemPicklistOption>;
}

/**
 * Check if a given object implements the FindAllLeadTaskWorkflowItemPicklistOptions200Response interface.
 */
export function instanceOfFindAllLeadTaskWorkflowItemPicklistOptions200Response(value: object): value is FindAllLeadTaskWorkflowItemPicklistOptions200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function FindAllLeadTaskWorkflowItemPicklistOptions200ResponseFromJSON(json: any): FindAllLeadTaskWorkflowItemPicklistOptions200Response {
    return FindAllLeadTaskWorkflowItemPicklistOptions200ResponseFromJSONTyped(json, false);
}

export function FindAllLeadTaskWorkflowItemPicklistOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllLeadTaskWorkflowItemPicklistOptions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TaskWorkflowItemPicklistOptionFromJSON)),
    };
}

export function FindAllLeadTaskWorkflowItemPicklistOptions200ResponseToJSON(json: any): FindAllLeadTaskWorkflowItemPicklistOptions200Response {
    return FindAllLeadTaskWorkflowItemPicklistOptions200ResponseToJSONTyped(json, false);
}

export function FindAllLeadTaskWorkflowItemPicklistOptions200ResponseToJSONTyped(value?: FindAllLeadTaskWorkflowItemPicklistOptions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(TaskWorkflowItemPicklistOptionToJSON)),
    };
}

